import { NeedsCategoryDto } from '@act/shared/data-transfer-objects';
import { PaginatedTableProps } from '@act/storybook';
import { metaSliceSelectors } from 'redux/slices/metaSlice';
import { NeedsCategoriesTableColumns } from './NeedsCategoriesColumns';
import { AdminToolSkeleton } from '../../AdminToolSkeleton';
import { IndexChildContainer } from 'react-components/member-index/indexContainer';
import { PaginatedTable } from '@act/storybook';
import { useMemo, useState } from 'react';
import { NeedsCategoriesCreateEdit } from './NeedsCategoriesCreateEdit';

export const NeedsCategories = () => {
  const [categoryCreate, setCategoryCreate] = useState(false);
  const [categoryEdit, setCategoryEdit] = useState(false);
  const [selectedCategory, setSelectedCategory] =
    useState<NeedsCategoryDto | null>(null);
  const needs = metaSliceSelectors.useSelectNeedsMetadata().data;
  const columns = useMemo(() => {
    return NeedsCategoriesTableColumns(needs?.domains);
  }, [needs?.categories]);
  const NEEDS_CATEGORIES_ADMIN_TABLE_PROPS: PaginatedTableProps<NeedsCategoryDto> =
    {
      data: needs?.categories,
      columnConfig: columns,
      inMemoryPagination: true,
      onRowClick: (row: NeedsCategoryDto) => {
        setSelectedCategory(row);
        setCategoryEdit(true);
      },
    };
  const setFormOpen = (value: boolean) => {
    if (!value) {
      setCategoryEdit(false);
      setSelectedCategory(null);
    }
  };

  return (
    <>
      <AdminToolSkeleton
        title="Needs Categories"
        toolDescription="Needs categories can be viewed and updated here."
        buttonContent="Add New Needs Category"
        variant="contained"
        onClick={() => setCategoryCreate(true)}
      >
        <IndexChildContainer>
          <PaginatedTable {...NEEDS_CATEGORIES_ADMIN_TABLE_PROPS} />
        </IndexChildContainer>
        {(categoryCreate || categoryEdit) && (
          <NeedsCategoriesCreateEdit
            open={categoryCreate || categoryEdit}
            setOpen={categoryCreate ? setCategoryCreate : setFormOpen}
            isEdit={categoryEdit}
            selectedCategory={selectedCategory}
          />
        )}
      </AdminToolSkeleton>
    </>
  );
};
